import { ProviderConfig, withLDProvider } from 'launchdarkly-react-client-sdk';
import { ComponentType } from 'react';

import { env } from '@neo.tax/shared/utils';

import { FeatureFlags } from './launch-darkly.types';

const convertCamelCaseToKebabCase = (value: string): string => value.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

// default values of feature flags (i.e. used shortly before values are loaded from Launch Darkly server)
const defaultFlags: FeatureFlags = {
  debugMode: false,
  enableMaintenanceMode: false,
  // providers
  enableAccountingCsvUpload: false,
  enableAdpRun: false,
  enableAdpWorkforceNow: false,
  enableAsana: false,
  enableAzureDevops: false,
  enableCeridianDayforce: false,
  enableGithub: false,
  enableGusto: false,
  enableIntuitSso: false,
  enableJira: false,
  enableJiraDataCenter: false,
  enableJustworks: false,
  enableLinear: false,
  enableNetsuite: false,
  enablePaychexFlex: false,
  enablePaylocity: false,
  enablePayrollCsvUpload: false,
  enableQuickbooks: false,
  enableQuickbooksPayroll: false,
  enableRippling: false,
  enableShortcut: false,
  enableTrello: false,
  enableTrinet: false,
  enableWorkday: false,
  enableZenefits: false,
  // other features
  enableMongoDbSandboxData: false,
  enableShortYearQuestions: false,
  enableSredProduct: false,
};

const defaultFlagsInKebabCase = Object.entries(defaultFlags).reduce(
  (all, [key, value]) => ({
    ...all,
    [convertCamelCaseToKebabCase(key)]: value,
  }),
  {},
);

const launchDarklyConfig: ProviderConfig = {
  clientSideID: env.REACT_APP_LAUNCHDARKLY_ID,
  flags: defaultFlagsInKebabCase,
};

export const wrapWithLDProvider = (
  Component: ComponentType<Record<string, unknown>>,
): ComponentType<Record<string, unknown>> => {
  const WrappedComponent = withLDProvider(launchDarklyConfig)(Component);
  // see react/display-name eslint rule
  WrappedComponent.displayName = `LDProviderWrapped${Component.displayName ?? Component.name}`;
  return WrappedComponent;
};
